module.exports = __webpack_public_path__ + "static/media/1-1@2x.c02560a6.png";